import useUserId from '@hooks/useUserId'
import useWebsiteId from '@hooks/useWebsiteId'
import useWebsiteLoyaltyConfig from '@page-components/CheckoutV3/hooks/useWebsiteLoyaltyConfig.main'
import useShouldUseLoyaltyV2 from '@page-components/CheckoutV3/sections/useShouldUseLoyaltyV2'
import WebsiteCoinsImage from '@page-components/CheckoutV3/sections/WebsiteCoins/WebsiteCoinsCount/WebsiteCoinsImage'
import LoginButton from '@page-components/Layout/Website/Layouts/Default/Navbar/Menu/LoginButton'

import WebsiteCoin from './WebsiteCoin'

export default function WebsiteCoins() {
  const showJustoLoyaltyV2 = useShouldUseLoyaltyV2()
  const websiteId = useWebsiteId()
  const userId = useUserId()
  const {loyaltyProgramConfig: config} = useWebsiteLoyaltyConfig(websiteId)

  if (!showJustoLoyaltyV2) return null

  if (!config?.active || !websiteId) return null

  if (!userId)
    return (
      <div className="flex bg-red-600 py-5 px-7 rounded-md relative w-full max-w-4xl">
        <WebsiteCoinsImage />
        <div className="flex flex-col text-white ml-2 mr-7">
          <span>
            Comienza a acumular tus <span className="font-bold">{config.name}</span>
          </span>
          <span className="text-xs font-medium">
            Inicia sesión y acumula puntos con cada compra y canjealos por descuento en tu pedido
          </span>
        </div>
        <div className="absolute right-0 mr-8 text-white bg-black rounded font-medium text-xs px-5 py-2">
          <LoginButton />
        </div>
      </div>
    )

  return (
    <div className="w-full max-w-4xl">
      <WebsiteCoin config={config} websiteId={websiteId} />
    </div>
  )
}
